import { createContext, useContext } from "react"

export const ScreenSizeContext = createContext<{
  isMobile: boolean
} | null>(null)

export const useScreenSizeContext = () => {
  const context = useContext(ScreenSizeContext)
  if (!context) {
    throw new Error("This component requires a screen size context")
  }
  return context
}
